import React from 'react';
import { FaTimes } from 'react-icons/fa';
import '../styles/InventoryView.css';

export default function InventoryView({ data, onClose }) {
  if (!data) return null;

  return (
    <div className="inventory-view-overlay">
      <div className="inventory-view-modal">
        {/* Header */}
        <div className="inventory-view-header">
          <h2>Inventory Detailed Update</h2>
          <button className="inventory-view-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Content Box */}
        <div className="inventory-view-box">
          <h3 className="inventory-view-title">{data.item} Update</h3>
          <p>
            <strong>Date:</strong> {data.date}
          </p>
          <p>
            <strong>Item Code:</strong> {data.code}
          </p>
          <p>
            <strong>Quantity:</strong> {data.quantity}
          </p>
          <p>
            <strong>Update Action:</strong> {data.updateAction || 'Add to Stock'}
          </p>
          <p>
            <strong>Category:</strong> {data.category || '—'}
          </p>
          <p>
            <strong>Project:</strong> {data.project}
          </p>
          <p>
            <strong>Remark/Note:</strong> {data.remark}
          </p>
        </div>
      </div>
    </div>
  );
}
